// propertyFormatters.ts
export function formatInt(n: number | null | undefined): string {
  return typeof n === 'number' ? n.toLocaleString() : '—';
}

export function formatPrice(price: number | null | undefined): string {
  if (price === null || price === undefined) return '-';

  // Abbreviate numbers >= 1 billion
  if (price >= 1000000000) {
    const billions = price / 1000000000;
    return `$${billions.toLocaleString('en-US', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    })}B`;
  }

  // Abbreviate numbers >= 1 million
  if (price >= 1000000) {
    const millions = price / 1000000;
    return `$${millions.toLocaleString('en-US', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    })}M`;
  }

  return `$${price.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
}

export function formatPricePerSqft(price: number | null | undefined): string {
  if (
    price === null ||
    price === undefined ||
    price === 0 ||
    price === Infinity
  )
    return 'N/A';
  return `$${price.toFixed(2)}`;
}

export function formatSqFt(sqft: number | null | undefined): string {
  if (sqft === null || sqft === undefined || sqft <= 0) return '- sq ft';
  // Abbreviate numbers >= 1 million
  if (sqft >= 1000000) {
    const millions = sqft / 1000000;
    return `${millions.toLocaleString('en-US', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    })}M sq ft`;
  }
  // Abbreviate numbers > 10,000
  if (sqft > 10000) {
    const thousands = sqft / 1000;
    return `${thousands.toLocaleString('en-US', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    })}K sq ft`;
  }
  return `${sqft.toLocaleString('en-US', { maximumFractionDigits: 0 })} sq ft`;
}

export const getMarketTimeText = (
  status: string | null,
  daysOnMarket: number | null,
  daysSinceSold: number | null
): string => {
  if (
    status === 'Sold' &&
    typeof daysSinceSold === 'number' &&
    daysSinceSold > 0
  ) {
    return `Sold ${daysSinceSold} days ago`;
  }
  return typeof daysOnMarket === 'number'
    ? `On the market: ${daysOnMarket} days`
    : '—';
};
